const isBrowser = (): boolean => ![typeof window, typeof document].includes('undefined');

export default isBrowser;
